import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { type DealApi, type DealOaApi, oaDealStatus } from '@openx/types/deal';
import { useTranslation } from 'react-i18next';
import { useIsLegacyAmazonDeal } from '../hooks/useIsLegacyAmazonDeal';

type DetailsHeaderAlertsProps = {
  deal: DealOaApi | DealApi;
};

export const DetailsHeaderAlerts = ({ deal }: DetailsHeaderAlertsProps) => {
  const { t } = useTranslation();
  const isLegacyAmazonDeal = useIsLegacyAmazonDeal(deal.created_date, deal.deal_participants);

  if (deal.deleted === 1) {
    return (
      <Alert severity="warning">
        <Typography variant="body1">{t('This deal has been deleted.')}</Typography>
      </Alert>
    );
  }

  return (
    <>
      {deal.status === oaDealStatus.EXPIRED && (
        <Alert severity="warning">
          <Typography variant="body1">
            {t("Deal is expired, to reactivate it, edit or remove the end date and set the deal status to 'Active'")}
          </Typography>
        </Alert>
      )}
      {isLegacyAmazonDeal && (
        <Alert severity="warning">
          <Typography variant="body1">
            {t(
              "Changes to an existing deal's name will not appear in Amazon DSP. Pricing changes will be reflected in bid requests but will not update the deal details displayed in Amazon DSP."
            )}
          </Typography>
        </Alert>
      )}
    </>
  );
};
